module.exports = __webpack_public_path__ + "img/menu-6.c0e0d9ec.svg";